(function () {
  function productData() {
    return window.ceresReviewProduct || null;
  }

  function buildProductBlock(data) {
    var wrap = document.createElement("div");
    wrap.className = "oke-w-review-product";
    wrap.setAttribute("data-ceres-injected-product", "true");

    var product = document.createElement("div");
    product.className = "oke-product";

    if (data.image) {
      var thumb = document.createElement("div");
      thumb.className = "oke-product-thumbnail";
      var img = document.createElement("img");
      img.className = "oke-product-thumbnail-image";
      img.src = data.image;
      img.alt = data.title || "";
      img.width = 48;
      img.height = 48;
      thumb.appendChild(img);
      product.appendChild(thumb);
    }

    var details = document.createElement("div");
    details.className = "oke-product-details";

    var label = document.createElement("div");
    label.className = "oke-product-details-title";
    label.textContent = "Reviewing";
    details.appendChild(label);

    var name = document.createElement(data.url ? "a" : "span");
    name.className = "oke-product-details-name";
    name.textContent = data.title || "";
    if (data.url) name.href = data.url;
    details.appendChild(name);

    product.appendChild(details);
    wrap.appendChild(product);
    return wrap;
  }

  function injectProductRows(root) {
    var data = productData();
    if (!data || !data.title) return;

    var reviews = (root || document).querySelectorAll
      ? (root.matches && root.matches(".oke-w-review")
          ? [root]
          : root.querySelectorAll(".oke-w-review"))
      : document.querySelectorAll(".oke-w-review");

    reviews.forEach(function (review) {
      if (review.querySelector(".oke-w-review-product")) return;

      var sideContent =
        review.querySelector(".oke-w-review-side-expandContent") ||
        review.querySelector(".oke-w-review-side") ||
        review;

      sideContent.appendChild(buildProductBlock(data));
    });
  }

  function observeWidget() {
    var widget = document.querySelector("[data-oke-widget]");
    if (!widget) return;

    injectProductRows(widget);
    if (widget.__ceresProductObserver) return;

    var observer = new MutationObserver(function () {
      injectProductRows(widget);
    });

    widget.__ceresProductObserver = observer;
    observer.observe(widget, { childList: true, subtree: true });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", observeWidget);
  } else {
    observeWidget();
  }

  document.addEventListener("oke-script-loaded", function () {
    setTimeout(observeWidget, 500);
  });
})();
